import { useApiRoutes } from "./useApiRoutes";
import { useTeamConfig } from "../components/TeamConfigProvider";

import type { TOAuthState } from "src/shared/types/globalStotre.types";

export function useSeatGeek() {
  const { TEAM_SCHEMA } = useTeamConfig();
  const { seatGeekAuthURLApi } = useApiRoutes();

  async function connectSeatGeek(state: TOAuthState) {
    try {
      const { authUrl } = await seatGeekAuthURLApi.get();
      state = state || {};
      state.teamSchema = TEAM_SCHEMA;

      const stateStr = window.btoa(JSON.stringify(state)).replaceAll("=", "");
      const finalAuthUrl = authUrl.replace("STATE", stateStr);

      window.location.href = finalAuthUrl;
    } catch (error) {
      console.log(error);
    }
  }

  return { connectSeatGeek };
}
